export default __webpack_public_path__ + "static/media/globe.302c94e5.png";